// Common function to format date and time
const formatDateTime = (dateTimeString) => {
  const dateObject = new Date(dateTimeString);
  const hours = dateObject.getHours();
  const minutes = dateObject.getMinutes();
  const formattedTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
  return formattedTime;
};

// Common function to format date
const formatDate = (dateString) => {
  const dateObject = new Date(dateString);
  const year = dateObject.getFullYear().toString();
  const month = (dateObject.getMonth() + 1).toString().padStart(2, '0');
  const day = dateObject.getDate().toString().padStart(2, '0');
  return `${year}-${month}-${day}`;
};

const formatMonthStartEnd = (dateObj) => {
  if (!dateObj || !dateObj.$d) return null;
  const year = dateObj.$y;  
  const month = String(dateObj.$M + 1).padStart(2, "0");  
  const firstDay = `${year}-${month}-01`;
  const lastDayDate = new Date(year, dateObj.$M + 1, 0);
  const lastDay = `${year}-${month}-${String(lastDayDate.getDate()).padStart(2, "0")}`;

  return { firstDay, lastDay };
};


  export {formatDateTime,formatDate,formatMonthStartEnd}